module.exports = __webpack_public_path__ + "img/June 22-3.7aa3ff4.png";